/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import SectionContainer from '../SectionContainer';

// TODO: kill this if we don't need it (saving for "non-default" cardType)
export const SectionContainerStyled = styled(SectionContainer)`
  ${({ theme, cardType }) => {
    const mobileUp = theme.mediumUp();
    return css`
      /** padding-left: ${cardType === 'default' && mobileUp ? 0 : rem(16)};
      padding-right: ${cardType === 'default' && mobileUp ? 0 : rem(16)}; */
    `;
  }}
`;
